import React from 'react';
import Register from '../../views/Register/Register';
import { customerRegistration } from '../Authentication/RegisterActions';
import { connect } from 'react-redux';
import queryString from 'query-string';

class RegisterContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      registerError : null
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { dispatchRegistration, registration, location } = this.props;
    const parsed = queryString.parse(location.search)
    data.invitationCode = parsed.code;

    if (data.invitationCode) {
      dispatchRegistration(data, (err, data) => {

      });
    } else {
      this.setState({
        registerError: "You must be invited to use this portal, please check your email for your invitation form Calhoun."
      })
    }
  }

  render() {
    const { registration, location } = this.props;
    const {registerError} = this.state;

    const parsed = queryString.parse(location.search);
    let success = false;
    let errorText = false;
    if (registration.get('signupSuccess')) {
      success = registration.get('signupSuccess');
    }
    if (registration.get('error')) {
      errorText = registration.get('error').message;
    }

    return <Register errorText={errorText || registerError} success={success}
      //initialValues={{ invitationCode: parsed.code }} 
      //code={parsed.code}
      registration={registration} onSubmit={this.handleSubmit} />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchRegistration: (data, cb) => dispatch(customerRegistration(data, cb))
  };
}

function mapStateToProps(state) {
  return {
    registration: state.register
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer);


// WEBPACK FOOTER //
// ./src/containers/Register/RegisterContainer.js